import { render, staticRenderFns } from "./EPageSizeSelector.vue?vue&type=template&id=797b0d8e&"
import script from "./EPageSizeSelector.vue?vue&type=script&lang=js&"
export * from "./EPageSizeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('797b0d8e')) {
      api.createRecord('797b0d8e', component.options)
    } else {
      api.reload('797b0d8e', component.options)
    }
    module.hot.accept("./EPageSizeSelector.vue?vue&type=template&id=797b0d8e&", function () {
      api.rerender('797b0d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/pagination/EPageSizeSelector.vue"
export default component.exports